import { Box } from '@mui/material';
import React from 'react';
import { SpaceOption } from '../../types';
import { NameField } from './NameField';
import { SpaceSelector } from './SpaceSelector';

interface AgentFormProps {
  name: string;
  onNameChange: (value: string) => void;
  selectedSpaceId: string;
  onSpaceChange: (value: string) => void;
  spaces: SpaceOption[];
  disabled?: boolean;
  showSpaceSelector?: boolean;
}

export const AgentForm: React.FC<AgentFormProps> = ({
  name,
  onNameChange,
  selectedSpaceId,
  onSpaceChange,
  spaces,
  disabled = false,
  showSpaceSelector = true,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <NameField
        value={name}
        onChange={onNameChange}
        label='Enter agent name'
        disabled={disabled}
      />
      {showSpaceSelector && (
        <SpaceSelector
          value={selectedSpaceId}
          onChange={onSpaceChange}
          spaces={spaces}
          disabled={disabled}
          required
        />
      )}
    </Box>
  );
};
